import React, { useEffect, useRef, useState } from 'react';
import { LuCloudOff, LuWifi } from 'react-icons/lu';
import './ConnectivityBanner.css';
import { offlineIllustration } from '../assets/catalog';

const ConnectivityBanner = () => {
  const [status, setStatus] = useState(() => (
    typeof navigator !== 'undefined' && navigator.onLine === false ? 'offline' : 'online'
  ));
  const [visible, setVisible] = useState(status === 'offline');
  const hasDisconnected = useRef(status === 'offline');

  useEffect(() => {
    let hideTimer;
    const handleOffline = () => {
      window.clearTimeout(hideTimer);
      hasDisconnected.current = true;
      setStatus('offline');
      setVisible(true);
    };
    const handleOnline = () => {
      setStatus('online');
      if (hasDisconnected.current) {
        setVisible(true);
        hideTimer = window.setTimeout(() => setVisible(false), 3500);
      }
    };
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.clearTimeout(hideTimer);
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (!visible) return null;
  const offline = status === 'offline';
  const Icon = offline ? LuCloudOff : LuWifi;

  return (
    <div
      className={`connectivity-banner connectivity-banner--${status}`}
      role="status"
      aria-live="polite"
    >
      {offline ? (
        <img className="connectivity-banner-illustration" src={offlineIllustration} alt="" />
      ) : (
        <Icon aria-hidden="true" />
      )}
      <span>
        <strong>{offline ? 'You are offline' : 'Connection restored'}</strong>
        {offline
          ? ' Changes that need the server may not be saved.'
          : ' Live workspace data can update again.'}
      </span>
      {offline && (
        <button type="button" onClick={() => window.location.reload()}>
          Retry
        </button>
      )}
    </div>
  );
};

export default ConnectivityBanner;
